/**
 * Formats a number with commas as thousand separators.
 *
 * @param input - The number (or a numeric string) to format.
 * @returns A string with commas separating thousands, or '' if input is not a valid number.
 *
 * @example
 * formatNumberWithCommas(1234567); // "1,234,567"
 * formatNumberWithCommas("9876543210"); // "9,876,543,210"
 * formatNumberWithCommas(-123456.78); // "-123,456.78"
 * formatNumberWithCommas("abc"); // ""
 */
export function formatNumberWithCommas(input: number | string): string {
  if (input === 0 || input === '0') {
    return '0';
  }

  if (!input) {
    return '';
  }

  const num = typeof input === 'string' ? Number(input) : input;

  if (Number.isNaN(num) || !num) {
    return '';
  }

  const [integerPart, decimalPart] = num.toString().split('.');

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
}
